import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { t } from "i18next";

/**
 * Acción de admin: ejecuta el comando que genera las facturas de liquidación
 * de los balances pendientes (1 factura por productor). Al terminar, refresca
 * el listado.
 */
function useGenerateInvoicesAction(indexFunction: any): any {
  const errorHandler = useErrorHandler();

  const generateInvoicesFunction = () => {
    // eslint-disable-next-line no-alert
    if (!window.confirm(t("generate_invoices_confirm"))) {
      return;
    }
    store("balances/generate-invoices", {})
      .then(() => {
        // eslint-disable-next-line no-alert
        window.alert(t("generate_invoices_done"));
        if (indexFunction) {
          indexFunction();
        }
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };

  return { generateInvoicesFunction };
}

export default useGenerateInvoicesAction;
